import { Typography } from '@workspace/ui/components/Typography';
import { Heart24 } from '@workspace/ui/icons';
import { useTranslation } from 'react-i18next';
import { company } from '~/company/Company';
import Icon from '~/components/Icon/Icon';
import { EmptyTitleComponent } from './EmptyTitleComponent';

const EmptySubtitleComponent = company.match({
  mcosmetic: Typography.Text200Medium,
  default: Typography.Text200MediumHigh,
});

const EmptyFavs = () => {
  const { t } = useTranslation();

  return (
    <div className="page-empty">
      <img
        src={company.images.favs.empty}
        className="page-empty__image"
        alt=""
      />
      <EmptyTitleComponent className="text-center">
        {t('phrases:emptyFavorites')}
      </EmptyTitleComponent>
      <EmptySubtitleComponent className="mt-4! inline-flex items-center gap-2 text-center text-text-tertiary">
        {t('phrases:addProducts')}{' '}
        {company.match({
          mcosmetic: <Heart24 className="fill-icon-brand text-icon-brand" />,
          default: (
            <Icon type="fav-fill" className="text-text-secondary" size={24} />
          ),
        })}
      </EmptySubtitleComponent>
    </div>
  );
};

export default EmptyFavs;
